import { render } from "./SuperSavingMoneyCardGetRecord.vue?vue&type=template&id=0c255562&scoped=true"
import script from "./SuperSavingMoneyCardGetRecord.vue?vue&type=script&lang=js"
export * from "./SuperSavingMoneyCardGetRecord.vue?vue&type=script&lang=js"

import "../../../styles/van-sticky-nav.css?vue&type=style&index=0&id=0c255562&scoped=scoped&lang=css"
import "./SuperSavingMoneyCardGetRecord.vue?vue&type=style&index=1&id=0c255562&scoped=scoped&lang=css"

import exportComponent from "/Users/leaf/Desktop/gmhwork/h5/zksq_H5/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c255562"]])

export default __exports__